/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var tabPanelProps = {
  "default": {
    type: Function
  },
  destroyOnHide: {
    type: Boolean,
    "default": true
  },
  disabled: Boolean,
  label: {
    type: [String, Function]
  },
  panel: {
    type: [String, Function]
  },
  removable: Boolean,
  value: {
    type: [String, Number]
  },
  onRemove: Function
};

export { tabPanelProps as default };
//# sourceMappingURL=tab-panel-props.mjs.map
